import { Reveal } from "./Reveal";
import { PROCESS_STEPS } from "@/lib/svenData";

export const Process = () => (
  <section id="process" data-testid="bespoke-process-section" className="bg-[#0b0b0c] py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="overline-label mb-5">The Bespoke Process</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-medium text-[#faf8f5] leading-snug">
              Five steps.<br />
              <em className="font-accent text-[#dfcca4]">One silhouette.</em>
            </h2>
            <p className="mt-6 text-sm font-light leading-relaxed text-white/55 max-w-xs">
              From the first measurement to the final press, every garment moves through
              the same unhurried hands.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          {PROCESS_STEPS.map((s, i) => (
            <Reveal key={s.num} delay={0.06 * i}>
              <div
                data-testid={`process-step-${s.num}`}
                className="group grid sm:grid-cols-12 gap-3 sm:gap-6 py-8 border-t border-white/10 last:border-b hover:bg-white/[0.03] transition-colors px-3 -mx-3"
              >
                <span className="sm:col-span-2 font-accent italic text-3xl text-[#c5a059]/70 group-hover:text-[#c5a059] transition-colors leading-none">{s.num}</span>
                <h3 className="sm:col-span-4 font-display text-xl text-[#faf8f5]">{s.title}</h3>
                <p className="sm:col-span-6 text-sm font-light leading-relaxed text-white/55 group-hover:text-white/75 transition-colors">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
